import styled, { css } from "styled-components";
import React from "react";
import { getByType, IRewardPoints } from "apps/BWW_PLAY_HUB/components/HubStats/utils";


interface IProgressBarWrapper {
	bg_color: string;
	is_vertical: boolean;
	stars_zero: boolean;
}

const isStarsOnZeroProgressBarWrapper = ({ stars_zero }: IProgressBarWrapper) =>
	stars_zero &&
	css`
		position: relative;
		
		${ProgressBarLine} {
			position: absolute;
			left: 0;
			bottom: 0;
		}
	`;

const isVerticalProgressBarWrapper = ({ is_vertical }: IProgressBarWrapper) =>
	is_vertical &&
	css`
		flex-direction: column;
		border-radius: 5px;
		height: 100%;
		width: 9.5px;
	`;

const ProgressBarWrapper = styled.div<IProgressBarWrapper>`
	height: 17px;
	width: 100%;
	border-radius: 8.5px;
	background-color: ${(props) => props.bg_color};
	overflow: hidden;
	display: flex;
	${isStarsOnZeroProgressBarWrapper}
	${isVerticalProgressBarWrapper}
`;

interface IProgressBarLine {
	color: string;
	percent: number;
	index: number;
	is_vertical: boolean;
}

const isVerticalProgressBarLine = ({ is_vertical, percent }: IProgressBarLine) =>
	is_vertical &&
	css`
		height: ${percent}%;
		width: 9.5px;
		border-radius: 5px 5px 0 0;
		
		&:before {
			display: none;
		}
	`;

const ProgressBarLine = styled.div<IProgressBarLine>`
	height: 17px;
	width: ${(props) => props.percent}%;
	background-color: ${(props) => props.color};
	border-radius: 0 8.5px 8.5px 0;
	transition: width 0.3s linear;
	position: relative;
	z-index: ${(props) => 10 - props.index};
	${isVerticalProgressBarLine}
	
	&:before {
		position: absolute;
		left: 0;
		top: 0;
		transform: translateX(-99%);
		content: '';
		width: 18px;
		height: 17px;
		background-color: ${(props) => props.color};
	}
`;

export const HubStatsProgressBarWithCount = styled.div`
	${ProgressBarWrapper} {
		margin-top: 20px;
		margin-bottom: 25px;
	}
`;

interface IProgressBar {
	items: IRewardPoints[],
	vertical?: boolean;
	bg_color?: string;
}

export const HubStatsProgressBar: React.FC<IProgressBar> = ({ items, vertical = false, bg_color = '#1C1C1C' }) => {
	return (
		<ProgressBarWrapper bg_color={bg_color} is_vertical={vertical} stars_zero={vertical}>
			{ items.map((item, index) => {
				const dataByType = getByType(item.type);

				if (!item.percent) {
					return null;
				}

				return (
					<ProgressBarLine key={index} percent={item.percent} color={dataByType.color} index={index} is_vertical={vertical} />
				)
			})}
		</ProgressBarWrapper>
	);
};